const joinIds = (list) => {
  if (Array.isArray(list)) return list.length > 0 ? list.join(",") : "";
  return list || "";
};

// For getProfitAndLoss/getCashFlow, which map branches/projects/costCenters
// to Wafeq's __in params internally.
export const pickDimensionFilters = (filters = {}) => {
  const picked = {};
  if (joinIds(filters.branches)) picked.branches = filters.branches;
  if (joinIds(filters.projects)) picked.projects = filters.projects;
  if (joinIds(filters.costCenters)) picked.costCenters = filters.costCenters;
  return picked;
};

// For getBalanceSheet, which passes its params object to Wafeq verbatim.
export const pickDimensionQueryParams = (filters = {}) => {
  const params = {};
  const branches = joinIds(filters.branches);
  const projects = joinIds(filters.projects);
  const costCenters = joinIds(filters.costCenters);
  if (branches) params.branch__in = branches;
  if (projects) params.project__in = projects;
  if (costCenters) params.cost_center__in = costCenters;
  return params;
};
